import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import {fromJS, Map} from "immutable";
import InlineTable from "../../../components/InlineTable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import FormError from "../../../components/forms/FormError";
import DateInputField from "../../../components/forms/DateInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import TextInputField from "../../../components/forms/TextInputField";
import {validateIncludes, validatePresence} from "../../../lib/Validators";

const resultOptions = fromJS([
  { id: "accepted", title: "Accepted" },
  { id: "rejected", title: "Rejected" }
]);

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "productionDate");
  errors = validateIncludes(errors, values, "result", resultOptions.map(x => x.get("id")));
  errors = validatePresence(errors, values, "labName");
  errors = validatePresence(errors, values, "testNr");
  return errors.toJS();
}

class RecordWaterTestResultForPalletsForm extends Component {

  renderStepOne() {
    let {errors, handleSubmit, loading, onFind} = this.props;

    return (
      <div>
        <p>Records the same water test result for every pallet produced on the selected date.</p>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Production date"
              name="productionDate"
              showDatePicker={this.props.showDatePicker}
              component={DateInputField}
              />
            <Field
              label="Result"
              name="result"
              component={DropDownInputField}
              data={resultOptions}
              valueKey="id"
              titleKey="title"
              />
            <Field
              label="Lab name"
              name="labName"
              component={TextInputField}
              />
            <Field
              label="Test nr"
              name="testNr"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton
            label={loading ? "Searching…" : "Find pallets"}
            active={!loading}
            onClick={handleSubmit(values => onFind(values))} />
          <ActionButton label="Cancel" active={!loading} onClick={this.props.onCancel} />
        </div>
      </div>
    );
  }

  renderPallets() {
    let {pallets} = this.props;

    if (!Array.isArray(pallets) || pallets.length <= 0) {
      return <p>No water pallets were produced on this date.</p>;
    }

    let fields = fromJS([
      {field: "palletId", title: "Id", type: "id"},
      {field: "skus", title: "SKUs", type: "id"},
      {field: "testResult", title: "Test Result", type: "string"},
    ])

    let palletData = fromJS(pallets.map((pallet) => {
      return {
        palletId: pallet.palletId,
        skus: (pallet.skus || []).join(", "),
        testResult: (pallet.testResult || "-")
      }
    }));

    return (
      <div className="matchedPallets">
        <p><strong>{pallets.length}</strong> pallet(s) will be updated:</p>
        <div className="fields">
          <InlineTable fields={fields} data={palletData} />
        </div>
      </div>
    );
  }

  renderStepTwo() {
    let {errors, handleSubmit, submitting, pallets, onBack} = this.props;
    let hasPallets = Array.isArray(pallets) && pallets.length > 0;

    return (
      <div>
        {this.renderPallets()}
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton
            label={submitting ? "Standby…" : "Record test result"}
            active={hasPallets && !submitting}
            onClick={handleSubmit(values => this.props.onSubmit(values))} />
          <ActionButton label="Back" active={!submitting} primary={false} onClick={onBack} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={(e) => e.preventDefault()}>
        {this.props.step === 2 ? this.renderStepTwo() : this.renderStepOne()}
      </form>
    );
  }
}

const ReduxForm = reduxForm({
  form: "RecordWaterTestResultForPalletsForm",
  validate: validateForm,
  destroyOnUnmount: true
})(RecordWaterTestResultForPalletsForm);

export default ReduxForm;
